import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'app/shared/services/dialog.service';
import { ItemService } from 'app/shared/services/item.service';
import { AuthService } from 'app/shared/services/auth.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import { NbThemeService } from '@nebular/theme';
import { EnvService } from '../../../shared/services/env.service';



@Component({
  selector: 'app-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.css']
})
export class ItemComponent implements OnInit {

  isDark: boolean = false;
  itemForm: FormGroup;
  itemCategoryList: any[];
  warehouseList: any[];
  isItemCodeReadOnly : boolean= true;
  isValidFormData: boolean = true;
  showProcessingIndicator =false;
 

  imageUrl :any ="/assets/images/no_image.png"
  selectedFile : File = null;
  imageNameUpdate : string = '';

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };

  UNIT =[
    {value: 'PCS'},
    {value: 'kg'},
    {value: 'gm'},
    {value: 'mg'}, 
    {value: 'L'},
    {value: 'ml'},
    {value: 'm'},
    {value: 'ft'},
    {value: 'in'},
    {value: 'cm'},
    {value: 'mm'}, 
    {value: 'Kit'}, 
    {value: 'Pckt'}, 
    {value: 'Pack'}, 
    
  
  ];

  categoryList =[
    {value: 'Item'},
    {value: 'Service'},
  
  ];

  validationMessages = {
    'itemCode': { 'required': 'Item Code is required' },
    'description': { 'required': 'Description is required' }, 
  };

  formErrors = {
    'itemCode': "",
    'description': "",  
  };



  constructor(private fb: FormBuilder,
              private itemService: ItemService,
              private authService: AuthService,
              private toastr: ToastrService,
              private dialogService: DialogService,
              private themeService: NbThemeService,
              private router : Router, 
              private env: EnvService
             ) { }

  ngOnInit() {
    this.getItemCategoryList();
    this.initFormFields();
    this.getDataTableRowData();
    this.getControlPermissions();
 
   this.itemForm.valueChanges.subscribe((data) => {
    this.logValidationErrors(this.itemForm);
  });

  this.themeService.onThemeChange()
  .subscribe(themeName =>{
       this.isDark  = themeName.name ==='dark' ? true : false;
     });
 

  } // end oninit

  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='IM'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }

  getItemCategoryList(){
    this.itemService.getAllItemCategory()
     .subscribe(
        (data) => {
                  this.itemCategoryList = data
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });  
       
     }

    
  initFormFields() : void{
    this.itemForm = this.fb.group({
      id : [null],
      itemCode : ['',Validators.required],
      description : ['',Validators.required],
      category : [null],
      unit : [null],
      reorderLevel : [''],
      unitCost : [''],
      unitPrice : [''],
      qtyBal : [''],
      itemImage: [null],
    });
  }

  newButtonClick(): void {
    this.imageNameUpdate = '';
    this.itemForm.reset();
    this.enableForm();
    this.isItemCodeReadOnly = false;
    this.imageUrl ="/assets/images/no_image.png"
   }


  saveButtonClick(): void {
  
    this.logValidationErrors(this.itemForm,true);
    const formData  = this.mapFormValuesToModel()
          if(this.isFilledFromFields()){
            
              if(!this.itemForm.value.id){
                this.showProcessingIndicator = true;
                this.itemService.addItem(formData)
                .subscribe(
                  (res) => {
                              console.log(res);
                             if(res.success === 0){
                                this.toastr.error('This item code already exist.', 'warning');
                                this.showProcessingIndicator = false;
                             }else if(res.success === 1){
                                this.toastr.success('Record created successfully','Success');                          
                                this.showProcessingIndicator = false; 
                                this.newButtonClick();
                              }
                            },        
                  (err) =>  {
                              this.toastr.error('Failed to create record','Failure');                                                         
                              this.showProcessingIndicator = false;
                              if(err instanceof HttpErrorResponse){                 
                                if(err.status == 401){
                                  this.router.navigate(['/login']);
                                }
                              }
                              console.log(err);
                            }, 
                  )
  
                    

            }else{
            this.dialogService.openConfirmDialog('Are you sure you want to update this record?')
            .afterClosed().subscribe(res =>{
              if(res){
              this.showProcessingIndicator = true;
              this.itemService.updateItem(formData)
            .subscribe(
              (res) => {
                          this.toastr.success('Record updated successfully','Success');     
                          this.showProcessingIndicator = false;  
                          this.newButtonClick();
                        },        
              (err) =>  {
                          this.toastr.error('Failed to update record','Failure');
                          this.showProcessingIndicator = false;
                          if(err instanceof HttpErrorResponse){                 
                            if(err.status == 401){
                              this.router.navigate(['/login']);
                            }
                          }
                          console.log(err);
                        }, 
                      )

          }else{
            this.showProcessingIndicator = false;
          }
            })

        }

      }
      else{
        this.toastr.warning('Required Fields cannot be empty or invalid.','Error Message');
        this.showProcessingIndicator = false;
        
      } 
                       
         
   }

  
  


   enableForm():void{
    Object.keys(this.itemForm.controls).forEach(key => {
      this.itemForm.controls[key].enable();
      
    });

  }


  disableForm():void{
    Object.keys(this.itemForm.controls).forEach(key => {
      this.itemForm.controls[key].disable();   
    });

  }
  
  logValidationErrors(group: FormGroup = this.itemForm,isDirty :boolean=false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if(isDirty)
      {
        this.enableForm();
        this.itemForm.controls[key].markAsTouched();
      }
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } 
    });
  }


  isFilledFromFields() : boolean {
    for (var key in this.formErrors) {
      if (this.formErrors[key] !== null && this.formErrors[key] != "" && this.formErrors[key] != '')
          return false;
        }
        return true;
  }

  
  onFileSelected(event){
    this.selectedFile = <File> event.target.files[0];
    //show image 
    var reader = new FileReader();
    reader.onload = (event : any)=>{
      this.imageUrl = event.target.result;
    }
    reader.readAsDataURL(this.selectedFile);
  }

  mapFormValuesToModel(){
    
    const formData  = new FormData();         
    
      formData.append('itemCode',this.itemForm.value.itemCode);
      formData.append('description',this.itemForm.value.description);
      formData.append('category',this.itemForm.value.category);
      formData.append('unit',this.itemForm.value.unit);
      formData.append('reorderLevel', this.itemForm.value.reorderLevel); 
      formData.append('unitCost', this.itemForm.value.unitCost); 
      formData.append('unitPrice', this.itemForm.value.unitPrice); 
      formData.append('qtyBal', this.itemForm.value.qtyBal); 
      formData.append('createdBy',this.authService.getUserLoggedIn());

      if(this.selectedFile){
        formData.append('file', this.selectedFile, this.selectedFile.name);
        formData.append('isImage', 'yes');
      }else if(this.imageNameUpdate) {
        formData.append('file', this.imageNameUpdate);
        formData.append('isImage', 'update');
      }
      else{
        formData.append('file', null);
        formData.append('isImage', 'no');
      }

      return formData;

  }


activeStatus = false;
viewItem(item:any){
 
  this.itemForm.patchValue({  
    id          :item.Id,
    itemCode    :item.ItemCode,
    description :item.Description,
    category    : item.Category,
    unit         : item.Unit,
    reorderLevel: item.ReorderLevel,
    unitCost: item.UnitCost,
    unitPrice: item.UnitPrice,
    qtyBal: item.QtyBal,
    
  })


  if(item.ImageName){
    this.imageUrl = `${this.env.apiUrl}/${item.ImageName}`;
    this.imageNameUpdate = item.ImageName;
  }
 

}

getDataTableRowData(){
  let data = this.itemService.dataRow;
  if(data){
    this.viewItem(data);
  }
  else{
    this.newButtonClick();
  }

}



}
